export var DEFAULT_LANGUAGE = 'en';
export var DEFAULT_LOCALE = 'en-US';
export var LAST_NAME_FIRST_RESULT = ['zh', 'ja', 'ko'];
export var SUPPORTED_LANGUAGES = ['en', 'de', 'ja', 'nl', 'es', 'fr', 'it', 'pt', 'ru', 'ko', 'zh-CN', 'zh-Hans'];
export var SUPPORTED_LOCALES = ['en-US', 'de-DE', 'ja-JP', 'nl-NL', 'es-ES', 'fr-FR', 'it-IT', 'pt-BR', 'ru-RU', 'ko-KR', 'zh-CN', 'zh-Hans-CN'];